module.exports = __webpack_public_path__ + "img/happy-raising-hands.d2079e15.png";